import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxDateBoxModule, DxValidatorModule } from "devextreme-angular";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { ValueChangedEvent } from "devextreme/ui/date_box";
import { LabelMode } from "devextreme/common";
import { ValidationRule } from "devextreme/common";

@Component({
    selector: "gpd-datebox",
    imports: [CommonModule, DxDateBoxModule, DxValidatorModule, SvgIconComponent],
    template: `
    <div
      class="gpd-input gpd-datebox-container"
      [class.label-mode-outside]="labelMode === 'outside'"
    >
      <app-svg-icon
        icon="calendar"
        [size]="18"
        color="var(--color-grey-500)"
        class="calendar-icon"
      ></app-svg-icon>
      <dx-date-box
        [(value)]="value"
        [type]="type"
        [class]="'gpd-input ' + (customClass || '')"
        [readOnly]="readOnly"
        [disabled]="disabled"
        [displayFormat]="displayFormat"
        [dateSerializationFormat]="dateSerializationFormat"
        [openOnFieldClick]="openOnFieldClick"
        [showClearButton]="showClearButton"
        [placeholder]="placeholder"
        [width]="width"
        [hint]="hint"
        [label]="label"
        [labelMode]="labelMode"
        [inputAttr]="inputAttr"
        (onValueChanged)="onValueChangedHandler($event)"
        (onContentReady)="onContentReadyHandler($event)"
        (onOpened)="onOpenedHandler($event)"
        (onClosed)="onClosedHandler($event)"
        [buttons]="[]"
      >
        <dx-validator *ngIf="validationRules && validationRules.length > 0">
          <dxi-validation-rule
            *ngFor="let rule of validationRules"
            [type]="rule.type"
            [message]="rule.message"
            [validationCallback]="rule.validationCallback"
            [comparisonTarget]="rule.comparisonTarget"
            [comparisonType]="rule.comparisonType"
            [max]="rule.max"
            [min]="rule.min"
            [pattern]="rule.pattern"
            [trim]="rule.trim"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-date-box>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
      .gpd-datebox-container {
        position: relative;
        width: 100%;
        display: inline-block;
        min-width: 160px;
      }

      .calendar-icon {
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        pointer-events: none;
      }

      ::ng-deep .gpd-datebox-container.label-mode-outside .dx-datebox {
        margin-top: 20px !important;
      }

      ::ng-deep .gpd-datebox-container .dx-texteditor-input {
        padding-left: 36px !important;
      }

      .gpd-datebox-container:focus-within .calendar-icon {
        color: var(--color-primary);
      }

      .gpd-datebox-container.disabled .calendar-icon {
        color: var(--color-grey-400);
      }

      .gpd-datebox-container.label-mode-outside .calendar-icon {
        margin-top: 10px;
      }

      ::ng-deep .gpd-datebox-container.label-mode-outside .dx-label span {
        font-weight: 400 !important;
        color: var(--color-grey-900) !important;
        font-size: 13px !important;
        top: -20px !important;
      }
    `,
    ]
})
export class GpdDateboxComponent {
  // Value and basic properties
  @Input() value: Date | string | number | null = null;
  @Input() type: "date" | "datetime" | "time" = "date";
  @Input() readOnly: boolean = false;
  @Input() disabled: boolean = false;

  // Format properties
  @Input() displayFormat: string = "dd.MM.yyyy";
  @Input() dateSerializationFormat: string = "yyyy-MM-dd";

  // UI properties
  @Input() placeholder: string = "";
  @Input() width: string | number = "100%";
  @Input() customClass: string = "";
  @Input() hint: string = "";
  @Input() inputAttr: any = {};
  @Input() label: string = "";
  @Input() labelMode: LabelMode = "hidden";

  // Behavior properties
  @Input() openOnFieldClick: boolean = true;
  @Input() showClearButton: boolean = false;

  // Validation properties
  @Input() validationRules: ValidationRule[] = [];

  // Events
  @Output() ValueChange = new EventEmitter<Date | string | number | null>();
  @Output() onValueChanged = new EventEmitter<ValueChangedEvent>();
  @Output() contentReady = new EventEmitter<any>();
  @Output() opened = new EventEmitter<any>();
  @Output() closed = new EventEmitter<any>();

  onValueChangedHandler(event: ValueChangedEvent): void {
    console.log(event);
    
    this.ValueChange.emit(event.value);
    this.onValueChanged.emit(event);
  }

  onContentReadyHandler(event: any): void {
    this.contentReady.emit(event);
  }

  onOpenedHandler(event: any): void {
    this.opened.emit(event);
  }

  onClosedHandler(event: any): void {
    this.closed.emit(event);
  }
}
